import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BarePositionIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 16' {...props} fill='none'>
    <path
      d='M8 2.4V1M8 15v-1.4'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 2a6 6 0 100 12A6 6 0 008 2z'
      stroke='currentColor'
      strokeMiterlimit='10'
    />
    <path
      d='M13.6 8H15M1 8h1.4'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SvgWrapper>
);
export const PositionIcon = memo(BarePositionIcon);
